import { GetServerSidePropsContext } from 'next'

import IndividualPreconPage from '@/pages/precon/[precon]'
import { GenericPageProps } from '@/types/page'
import { serverSidePropsFor } from '@/utils/helpers.server'

const PreconSubCommanderPage = (props: GenericPageProps) => <IndividualPreconPage {...props} />

export const getServerSideProps = async (context: GetServerSidePropsContext) =>
  serverSidePropsFor(
    `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/precon/${context.query.precon}/${context.query.commander}.json`,
  )

export default PreconSubCommanderPage
